'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.Wrapper = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('./Button');

require('./BlankSlate.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = exports.Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      title = _ref.title,
      subTitle = _ref.subTitle,
      subTitle2 = _ref.subTitle2,
      bubbleImg = _ref.bubbleImg;

  var imgSrc = bubbleImg || require('../images/visual-stack/default-list-bs-img.png');
  var titleText = title || 'You do not have any content.';
  var subTitle2El = subTitle2 && _react2.default.createElement(
    'div',
    { className: 'bs-subtitle' },
    subTitle2
  );
  return _react2.default.createElement(
    'div',
    { className: 'row blankslate' },
    _react2.default.createElement('div', { className: 'col-xs-2' }),
    _react2.default.createElement(
      'div',
      { className: 'blank-slate col-xs-8' },
      _react2.default.createElement(
        'div',
        { className: 'blank-slate-img-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'bs-bubble-img' },
          _react2.default.createElement('img', { src: imgSrc })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'blankslate-title' },
        titleText
      ),
      _react2.default.createElement(
        'div',
        { className: 'bs-subtitle' },
        subTitle
      ),
      subTitle2El,
      children
    ),
    _react2.default.createElement('div', { className: 'col-xs-2' })
  );
};
Wrapper.propTypes = {
  title: _propTypes2.default.string,
  subTitle: _propTypes2.default.string,
  subTitle2: _propTypes2.default.string,
  bubbleImg: _propTypes2.default.string
};

var Button = exports.Button = function Button(_ref2) {
  var onClick = _ref2.onClick,
      text = _ref2.text;
  return _react2.default.createElement(
    'div',
    { className: 'bs-button-wrapper' },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h2',
        null,
        'Get started now!'
      ),
      _react2.default.createElement(
        _Button.Button,
        {
          className: 'bs-button',
          size: 'lg',
          type: 'primary',
          onClick: onClick },
        _react2.default.createElement(
          'span',
          { className: 'bs-button-text' },
          text || 'Create Content'
        )
      )
    )
  );
};
Button.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  text: _propTypes2.default.string
};

exports.default = Wrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cjdev/visual-stack/lib/components/BlankSlate.js
// module id = 852
// module chunks = 0